import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { SectionHeader } from '../../../partner-pages/utils/section-header';
import useGetApi from '../../../../hooks/use-get-api';

const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
});

const SimpleStepsSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const lottie =
    'https://assets.clear.in/cleartax/images/1757663691_itrflow.json';
  const { data: lottieAnimationData } = useGetApi(isInView ? lottie : '');
  return (
    <div ref={sectionRef} className="bg-brand-100">
      <div className="relative wg-container overflow-hidden w-full pt-24 sm:pt-8">
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-full h-full bg-white rounded-full" />
        <div className="relative z-10">
          <SectionHeader
            heading={'File ITR in 3 simple steps'}
            align="center"
            description={undefined}
            className="font-semibold text-s-46 md:text-s-32 sm:text-base"
          />
        </div>
        <div className="py-20 sm:py-10 pointer-events-none lg:pt-10 md:pt-10">
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: lottieAnimationData,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SimpleStepsSection;
